import api from '../axios.config';
import { API_ENDPOINTS, createEndpoint } from './endpoints';

export const VendorService = {
  listVendors: async (activeOnly = false) => {
    const endpoint = createEndpoint(API_ENDPOINTS.VENDOR.LIST, {
      active_only: activeOnly,
    });
    return api.get(endpoint);
  },

  createVendor: async (data) => api.post(API_ENDPOINTS.VENDOR.CREATE, data),

  updateVendor: async (id, data) => {
    const endpoint = createEndpoint(API_ENDPOINTS.VENDOR.UPDATE, { id });
    return api.patch(endpoint, data);
  },
};
